var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLovePotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.25C7.58579 1.25 7.25 1.58579 7.25 2C7.25 2.41421 7.58579 2.75 8 2.75H9.0315C9.01094 2.82991 9 2.91368 9 3V8.67363C6.63505 9.79709 5 12.2076 5 15C5 18.866 8.13401 22 12 22C15.866 22 19 18.866 19 15C19 12.2076 17.3649 9.79709 15 8.67363V3C15 2.91368 14.9891 2.82991 14.9685 2.75H16C16.4142 2.75 16.75 2.41421 16.75 2C16.75 1.58579 16.4142 1.25 16 1.25H8ZM8 14.4568C8 12.034 10.2001 11.1295 12 13.001C13.7999 11.1295 16 12.034 16 14.4568C16 15.9071 14.3922 17.441 13.2153 18.3695C12.6825 18.7898 12.4161 19 12 19C11.5839 19 11.3175 18.7898 10.7847 18.3695C9.60777 17.4409 8 15.9071 8 14.4568Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLovePotion);
export default __webpack_public_path__ + "static/media/love-potion.f1df4ec4662202824e8e1863ccad7d58.svg";
export { ForwardRef as ReactComponent };